import { domClassMerge } from '@propertyfinder/helpers';
import React from 'react';

var styles = {"toggle":"toggle-module_toggle__3jty2","toggle--checked":"toggle-module_toggle--checked__3nL3s","toggle__text":"toggle-module_toggle__text__2LOvK","toggle__chip":"toggle-module_toggle__chip__2hNzM","toggle__button":"toggle-module_toggle__button__394dy"};

const ToggleComponent = ({
  checked: _checked = false,
  children,
  className,
  onClick
}) => /*#__PURE__*/React.createElement("div", {
  className: domClassMerge(styles['toggle'], className, {
    [styles['toggle--checked']]: _checked
  })
}, children && /*#__PURE__*/React.createElement("div", {
  className: styles['toggle__text']
}, children), /*#__PURE__*/React.createElement("div", {
  className: styles['toggle__chip']
}), /*#__PURE__*/React.createElement("button", {
  className: styles['toggle__button'],
  onClick: onClick
}));

export { ToggleComponent };
